import React, { useEffect, useState } from "react";
import { adminStats } from "../../adminApi";
import { Users, Activity, ShoppingBag, Coins, Trophy, Bot, RefreshCw } from "lucide-react";

function StatCard({ icon: Icon, label, value, sub, accent = "blue" }) {
  const accents = {
    blue: "from-blue-500 to-blue-700",
    green: "from-emerald-500 to-emerald-700",
    amber: "from-amber-500 to-orange-600",
    purple: "from-purple-500 to-fuchsia-600",
    red: "from-red-500 to-rose-700",
  };
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider text-gray-500">{label}</p>
          <p className="text-3xl font-extrabold text-gray-900 mt-1" style={{ fontFamily: "'Playfair Display', serif" }}>
            {value}
          </p>
          {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
        </div>
        <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${accents[accent]} text-white flex items-center justify-center shadow`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      setStats(await adminStats());
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30 * 1000);
    return () => clearInterval(t);
  }, []);

  if (loading && !stats) return <p className="text-gray-500">Cargando...</p>;
  if (!stats) return <p className="text-gray-500">No hay datos.</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-2xl font-extrabold text-gray-900">Dashboard</h2>
        <button onClick={load} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-blue-50 hover:bg-blue-100 text-[#1d6cb1] text-sm font-semibold">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Refrescar
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Users}       label="Usuarios totales"   value={stats.users.total}            sub={`+${stats.users.new_24h} en 24h`}            accent="blue" />
        <StatCard icon={Activity}    label="Conectados ahora"   value={stats.online}                 sub={`${stats.sessions_24h} sesiones / 24h`}      accent="green" />
        <StatCard icon={Trophy}      label="Resultados hoy"     value={stats.results_today}                                                                accent="amber" />
        <StatCard icon={ShoppingBag} label="Compras totales"    value={stats.purchases.total}        sub={`RD$${stats.purchases.revenue_dop} ingresos`} accent="purple" />
        <StatCard icon={Bot}         label="Chats con Tauro"    value={stats.tauro.chats}                                                                  accent="red" />
        <StatCard icon={Coins}       label="An\u00e1lisis Tauro" value={stats.tauro.analyses}                                                              accent="amber" />
      </div>
    </div>
  );
}
